module.exports = "<h1 class=page-title>Fundels digitaal</h1> <p style=font-size:1.4rem;margin-top:15px> Wens je als organisatie of persoon gebruik te maken van Fundels maar vind je de juiste informatie niet onmiddellijk terug? Aarzel dan niet om contact op te nemen met ons Fundels-team op 09/226 09 07 of <a href=mailto:support@fundels.com>support@fundels.com</a>. We maken voor jou graag een prijs op maat! </p> ";


//////////////////
// WEBPACK FOOTER
// ./app/views/store/info/nl_NL/other.jsp
// module id = 685
// module chunks = 3